import React, { useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import { poktoolsLogos } from "../PoktoolsVariables";
import "./PoktoolsHome.scss";
import { Button } from "react-bootstrap";
import PerfectScrollbar from "react-perfect-scrollbar";
import { PoktoolsContext } from "../poktoolsContext";
import { sendCommand } from "../../components/Bridge";

function PoktoolsHome(props) {
  const { poktoolsState, dispatchPoktoolsState } = useContext(PoktoolsContext);

  const names = ["trainer", "fastpok", "rp"];

  const { t } = useTranslation();

  const subscribeClicked = () => {
    console.log("subscribe");
    sendCommand("gui/login/subscribeClicked");
  };

  useEffect(() =>
  {
    console.log("effect");
    return () => {};
  }, [poktoolsState]);

  return (
    <>
      {poktoolsState.xXeesterLicence === 0 ? (
        poktoolsState.remainingTime < 0 ? (
          <div className="poktools-warning" onClick={subscribeClicked}>
            {t("poktools.unauthorized")}
          </div>
        ) : (
          <div className="poktools-pending" onClick={subscribeClicked}>
            {t("poktools.pending").replace("[NB]", Math.ceil(poktoolsState.remainingTime/(3600*24*1000)))}
          </div>
        )
      ) : (
        <></>
      )}
      <div className="poktools-home">
        <PerfectScrollbar>
          <div className="welcome-cards">
            {names.map((name) => (
              <div className="welcome-card" key={name}>
                <div className="welcome-card-content">
                  <div className="logo">
                    <img src={poktoolsLogos[name]} alt=""></img>
                  </div>
                  <div className="title">
                    {t("poktools." + name + ".title")}
                  </div>
                  <div className="description">
                    {t("poktools." + name + ".description")}
                  </div>
                  <Button
                    className="start"
                    onClick={() => {
                      console.log("poktoolsState", poktoolsState);
                      props.history.push("/app/poktools/" + window.poktoolsLastUrls[name]
                      );
                    }}
                    disabled={
                      poktoolsState.xXeesterLicence === 0 &&
                      poktoolsState.remainingTime < 0
                    }
                  >
                    {t("poktools." + name + ".start")}
                  </Button>
                </div>
              </div>
            ))}
          </div>
        </PerfectScrollbar>
      </div>
    </>
  );
}
export default PoktoolsHome;
